<!---- Copyright The Linux Foundation and each contributor to LFX.-->
<!---- SPDX-License-Identifier: MITs -->
<div class="e-chart-container">
  <div class="e-chart-draw" #eChart></div>
</div>
